import script from "./securityUser.vue?vue&type=script&setup=true&lang=js"
export * from "./securityUser.vue?vue&type=script&setup=true&lang=js"

import "./securityUser.vue?vue&type=style&index=0&id=94c80eba&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94c80eba"]])

export default __exports__